class $7c6ad2e4b9beca8b$export$2e2bcd8739ae039 {
    constructor(){
        this.bodyElm = document.body;
        this.headerElm = this.bodyElm.querySelector("header");
        this.primaryNav = document.querySelector("#primary-navigation");
        this.navToggle = document.querySelector(".header__toggle.header--mobile");
        this.windowWidth = window.innerWidth;
        this.init();
    }
    init() {
        this.primaryNav;
        if (this.headerElm) this.onScroll();
    }
    // private mobileToggle() {
    //   this.navToggle.addEventListener("click", () => {
    //     let visibility = this.primaryNav.getAttribute("data-visible");
    //     if (visibility === "false") {
    //       this.primaryNav.setAttribute("data-visible", "true");
    //       this.navToggle.setAttribute("aria-expanded", "true");
    //     } else {
    //       this.primaryNav.setAttribute("data-visible", "false");
    //       this.navToggle.setAttribute("aria-expanded", "false");
    //     }
    //   });
    // }
    onScroll() {
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > 50) this.headerElm.classList.add("scroll");
            else this.headerElm.classList.remove("scroll");
        });
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    new (0, $7c6ad2e4b9beca8b$export$2e2bcd8739ae039)();
});


//# sourceMappingURL=home.227ec85a.js.map
